<bxi-page
  [title]="('property.list.title' | translate) + totalCount()"
  [supportingTitle]="'property.list.supportingTitle' | translate"
  [breadcrumbOptions]="breadcrumbOptions()"
  class="h-screen w-full"
>
  <bxi-ditto-grid
    class="h-full w-full"
    [columnDefs]="columnDefs()"
    [defaultColDef]="defaultColDef()"
    [dittoDatasource]="dittoDatasource()"
    [persistFiltersService]="persistFiltersService"
    [persistColumnDefsService]="persistColumnDefsService"
    [persistSortService]="persistSortService"
  />
</bxi-page>
